export default __webpack_public_path__ + "static/media/Close.2b6371de.svg";